import React from 'react';
import UQIcon from '../icon';
import './style.scss';

export interface UQCheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean, e?: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const UQCheckbox: React.FC<UQCheckboxProps> = ({
  checked = false,
  onChange,
  onClick,
  label,
  disabled = false,
  className = '',
  style,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    onChange?.(e.target.checked, e);
  };

  return (
    <label
      className={`uq-checkbox ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''} ${className}`}
      style={style}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        onClick={onClick}
        disabled={disabled}
        tabIndex={0}
      />
      <span className="uq-checkbox-icon">
        {checked ? (
          <UQIcon icon="check-square-contained" />
        ) : (
          <UQIcon icon="check-square-empty" />
        )}
      </span>
      {label && <span className="uq-checkbox-label">{label}</span>}
    </label>
  );
};

export default UQCheckbox;
